module.exports = __webpack_public_path__ + "media/trail/icons-controls-zoom-out-6d491e95.svg";